<template>
  <div class="prayer" @click="stateChange">
    <div class="prayer-icon-container p-3" :class="{'active' : active}">
      <img loading="lazy" sizes="100%, 100%" class="prayer-icon rounded img-fluid" :src="iconSource" :title="prayer.name"
           :alt="prayer.name">

<!--      <div class="ic">-->
<!--        <img loading="lazy" sizes="100%, 100%" class="prayer-icon rounded img-fluid" :src="iconSource" :title="prayer.name"-->
<!--             :alt="prayer.name">-->
<!--      </div>-->
    </div>
    <!--    <span class="prayer-name">{{prayer.name}}</span>-->
  </div>
</template>

<script>
  export default {
    name: "Prayer",
    props: {
      prayer: {
        type: Object
      },
      active: {
        type: Boolean,
        default() {
          return false;
        }
      }
    },
    computed: {
      iconSource: function () {
        return `data:image/jpeg;base64,${this.prayer.icon}`
      },
    },
    methods: {
      stateChange: function () {
        this.$emit('stateChange', this.prayer, !this.active)
      }
    }
  }
</script>

<style scoped>
  .ic {
    min-height: 30px;
  }
  .prayer-icon-container.active {
    display: inline-block;
    border-radius: 50%;
    background: #B5A16D;
  }

  .prayer-icon {
    width: auto;
    transform: scale(1.6);
    /*display: block;*/
    /*float: left;*/
  }

  .prayer-name {
    display: block;
    line-height: 0.8rem;
    font-size: 0.7rem;
    line-break: strict;
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs/prayer/Prayer.vue